<template>
  <div class="login-container" v-if="hasParams">
    <div class="login-form">
      <div class="login-bg-image">
        <img :src="store.getters.loginBG" />
      </div>
      <div class="login-form-container">
        <div class="login-title">成绩查询平台</div>
        <el-form
          label-position="top"
          :model="loginForm"
          style="width: 320px"
          size="large"
          :rules="rules"
          ref="ruleFormRef"
        >
          <el-form-item label="" v-show="false">
            <el-select
              style="width: 100%"
              v-model="loginForm.projectCode"
              placeholder="请选择考试"
            >
              <el-option
                v-for="exam in examList"
                :key="exam.code"
                :label="exam.name"
                :value="exam.code"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="考生姓名" prop="loginName">
            <el-input v-model="loginForm.loginName" />
          </el-form-item>
          <el-form-item label="身份证号码" prop="idNumber">
            <el-input v-model="loginForm.idNumber" />
          </el-form-item>
          <div id="captcha-button"></div>
          <div id="captcha-element"></div>
          <el-form-item>
            <el-button
              style="width: 100%"
              :disabled="disabled"
              type="primary"
              @click="onSubmit(ruleFormRef)"
              >登录</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
  <div class="tips" v-else>请通过手机端访问！</div>
</template>
<script setup>
import {
  ElForm,
  ElFormItem,
  ElInput,
  ElSelect,
  ElOption,
  ElButton,
  ElMessage,
} from "element-plus";
import { ref, reactive, computed, onMounted } from "vue";
import { getAllTestFiles, login, getEncryptedSceneId } from "api/index";
import { useRouter, useRoute } from "vue-router";
import cookie from "js-cookie";
import { useStore } from "vuex";

function IsPC() {
  let userAgentInfo = navigator.userAgent;
  let Agents = new Array(
    "Android",
    "iPhone",
    "SymbianOS",
    "Windows Phone",
    "iPad",
    "iPod"
  );
  let flag = true;
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
}

if (!IsPC()) {
  window.location = location.href.replace("/web", "");
}
const hasParams = computed(() => {
  return route.query.type != null;
});

const store = useStore();
const route = useRoute();
const router = useRouter();
store.commit("saveTestCode", route.query.type || "");

const ruleFormRef = ref(null);
const loginForm = reactive({
  loginName: "",
  idNumber: "",
  projectCode: route.query.type || "",
});
const rules = reactive({
  loginName: [{ required: true, message: "请填写考生姓名", trigger: "blur" }],
  idNumber: [
    {
      required: true,
      message: "请填写身份证号码",
      trigger: "blur",
    },
  ],
});

/** 登录  */
const captcha = ref(null);
const captchaButton = ref(null);
// 获取后端加密后的 SceneId
const getEncryptedSceneIdFn = async () => {
  const { data } = await getEncryptedSceneId();
  return data;
};
// 滑块验证的信息
const slideInformation = ref({
  captchaVerifyParam: "",
  sceneId: "",
});
const disabled = ref(true);
const init = async () => {
  const { encryptedSceneId, sceneId } = await getEncryptedSceneIdFn();
  window.initAliyunCaptcha({
    SceneId: sceneId, // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
    EncryptedSceneId: encryptedSceneId, // 加密字符串
    mode: "embed", // 弹出式 popup  嵌入式 embed
    element: "#captcha-element", // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
    button: "#captcha-button", // 触发验证码弹窗的元素。
    success: (data) => {
      disabled.value = false;
      slideInformation.value.captchaVerifyParam = data;
      slideInformation.value.sceneId = sceneId;
    },
    // 验证码验证不通过回调函数
    fail: (result) => {
      console.error(result);
    },
    getInstance: (instance) => {
      captcha.value = instance;
    }, // 绑定验证码实例函数，无需修改
    slideStyle: {
      width: 320,
      height: 36,
    }, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
    language: "cn", // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
  });
};
const onSubmit = async (formEl) => {
  if (!formEl) return;
  await formEl.validate(async (valid, fields) => {
    if (valid) {
      store.commit("setProjectCode", loginForm.projectCode);
      const { data, message } = await login({
        projectCode: loginForm.projectCode,
        loginName: loginForm.loginName,
        loginPwd: "",
        idNumber: loginForm.idNumber,
        captchaV2: slideInformation.value,
      });
      if (!data) {
        ElMessage({
          message,
          type: "warning",
        });
      } else {
        const { credentialsID, projectName } = data;
        store.commit("saveCredentialsID", credentialsID);
        store.commit("saveProjectName", projectName);
        router.push(`/web/home/${loginForm.projectCode}`);
      }
    }
  });
};
const examList = ref([]);

const getAllFiles = async () => {
  const { data } = await getAllTestFiles();
  examList.value = data.sort((a, b) => a.order - b.order);
};
cookie.remove("data");
onMounted(() => {
  captchaButton.value = document.getElementById("#captcha-button");
  init();
});
// 获取全部考试项目
getAllFiles();
let slide = document.getElementById("nc_1_nocaptcha");
if (slide) {
  slide.remove();
}
</script>
<style lang="scss" scoped>
.login-container {
  display: flex;
  height: 100%;
  justify-content: center;
  background-color: #eee;

  :deep(.sm-pop-inner) {
    position: relative;
    margin-bottom: 50px;
  }
  :deep(.nc-container #nc_1_wrapper) {
    width: 100%;
  }
}
.login-bg-image {
  width: 370px;
  height: 462px;
  img {
    width: 100%;
    height: 100%;
  }
}

.login-form {
  display: flex;
  align-items: center;
  justify-content: center;
  // background-color: #1b20f4;
  &-container {
    padding: 30px;
    background-color: #fff;
  }
}
.login-title {
  font-size: 24px;
  color: #1c264f;
  text-align: center;
  font-weight: 500;
  margin-bottom: 40px;
}

.tips {
  position: relative;
  top: 50%;
  font-size: 24px;
  color: #1c264f;
  text-align: center;
}
</style>
